export default __webpack_public_path__ + "static/menu-image3-e4fe193b9cbdc427864322736d836599.jpg";